export interface MappingReadinessCatalogStateInput {
  projectCatalogLoading: boolean;
  projectCatalogLoaded: boolean;
  projectCatalogMatchesProject: boolean;
  projectCatalogHasError: boolean;
  autoRepair: boolean;
  runtimeAvailable: boolean;
  hostRuntimeAvailable: boolean;
  repairableCount: number;
  sampledCatalogReady: boolean;
  referenceCount: number;
  familySatisfactionApplies: boolean;
  familySatisfactionReady: boolean;
  missingCount: number;
}

export interface MappingReadinessCatalogState {
  projectCatalogReady: boolean;
  waitingForSampledCatalog: boolean;
  catalogLoading: boolean;
  catalogReady: boolean;
  repairStartHold: boolean;
  catalogUnavailable: boolean;
}

/**
 * Pure catalog-readiness verdict for the mapping readiness hook: when the
 * project/sampled catalogs count as loading or ready, when a failed project
 * read makes the catalog unavailable, and when an unresolved family snapshot
 * must hold the repair start (the diff can still list family-resident
 * parameters as missing, so auto-repair never fires on stale information).
 */
export function resolveMappingReadinessCatalogState(
  input: MappingReadinessCatalogStateInput
): MappingReadinessCatalogState {
  const projectCatalogReady = input.projectCatalogLoaded && input.projectCatalogMatchesProject;
  const waitingForSampledCatalog =
    input.autoRepair &&
    input.runtimeAvailable &&
    projectCatalogReady &&
    input.repairableCount > 0 &&
    !input.sampledCatalogReady;

  return {
    projectCatalogReady,
    waitingForSampledCatalog,
    catalogLoading: input.projectCatalogLoading || waitingForSampledCatalog,
    catalogReady: projectCatalogReady && !waitingForSampledCatalog,
    repairStartHold:
      input.familySatisfactionApplies && !input.familySatisfactionReady && input.missingCount > 0,
    catalogUnavailable:
      !input.projectCatalogLoading &&
      input.hostRuntimeAvailable &&
      input.referenceCount > 0 &&
      !projectCatalogReady &&
      input.projectCatalogHasError,
  };
}
